<template>
  <Layout>
    <div class="mc-liveview__map mc-liveview__map--notification">
      <GmapMap
        id="map"
        ref="MapAddress"
        :center="{
          lat: parseFloat(detail.latitude),
          lng: parseFloat(detail.longitude),
        }"
        :zoom="14"
        class="mc-map"
      >
        <gmap-custom-marker
          :offsetY="25"
          :marker="{
            lat: detail.latitude ? parseFloat(detail.latitude) : '',
            lng: detail.longitude ? parseFloat(detail.longitude) : '',
          }"
        >
          <img
            :src="require(`@/assets/images/vehicles/van/van-dark-grey.png`)"
            :style="`transform: rotate(${parseInt(90)}deg);`"
            :alt="`mceasy-liveview-van-icon`"
          />
        </gmap-custom-marker>
        <GmapInfoWindow
          :position="{
            lat: detail.latitude ? parseFloat(detail.latitude) : '',
            lng: detail.longitude ? parseFloat(detail.longitude) : '',
          }"
          :opened="true"
        >
          <div class="mc-modal-fleet mc-modal-fleet--notif">
            <div class="mc-modal-fleet__item">
              <!-- username  -->
              <h3 class="mc-modal-fleet__item-title">
                {{ `${detail?.vehicle.licensePlate} - ${detail?.driver.fullname}` }}
                <a
                  @click="
                    $router.push({
                      name: 'Detail Driver Score V2',
                      params: { driverId: Number(detail?.driverId) },
                    })
                  "
                >
                  <i class="mc-fa icon-outline_close"></i>
                </a>
              </h3>
              <div>
                <div
                  class="mc-modal-fleet__item-status mc-modal-fleet__item-status--notif clearfix mb-3 mt-3"
                >
                  <h4 :class="`text-${checkAlert(detail?.alertCode)} float-start w-50`">
                    {{ convertAlert(detail?.alertCode) }}
                  </h4>
                  <div class="float-end w-50 text-end">
                    <b-button
                      :disabled="true"
                      v-b-modal.modal-call
                      :title="$t('notification.action.callDriver')"
                      class="float-end"
                      variant="outline-primary"
                    >
                      <i class="mc-fa icon-outline_phone"></i>
                      {{ $t('notification.action.callDriver') }}
                    </b-button>
                  </div>
                </div>
                <dl class="mc-modal-fleet__item-list clearfix">
                  <dt>{{ $t('global.time.time') }}</dt>
                  <dd>
                    {{ momentDateShortMonth(detail.createdOn) }} -
                    {{ momentTimeSeconds(detail.createdOn) }} WIB
                  </dd>
                  <dt>{{ $t('liveView.infoWindow.location') }}</dt>
                  <dd>{{ detail.address }}</dd>
                  <dt v-if="detail.alertCode == '8'">
                    {{
                      detail.alertCode == '8'
                        ? $t('liveView.infoWindow.speed')
                        : $t('global.alert.temperature')
                    }}
                  </dt>
                  <dd v-if="detail.alertCode == '8'">
                    {{
                      `${
                        detail.formattedAlertData !== '-'
                          ? parseFloat(detail.formattedAlertData).toFixed(0)
                          : '-'
                      } ${$t('global.unit.kmPerHour')}`
                    }}
                  </dd>
                  <dt v-if="detail.alertCode == '8'">{{ $t('global.object.limit') }}</dt>
                  <dd v-if="detail.alertCode == '8'">
                    {{ `${detail.alertTrigger} ${$t('global.unit.kmPerHour')}` }}
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </GmapInfoWindow>
      </GmapMap>
    </div>
    <b-modal
      class="mc-modal"
      id="modal-call"
      ref="modal-call"
      :title="$t('nofitication.action.callDriver')"
      header-bg-variant="primary"
      header-close-variant="light"
      :ok-title="$t('global.action.register')"
      :cancel-title="$t('global.action.close')"
      cancel-variant="outline-primary"
      size="md"
      centered
    >
      <b-row align-h="center">
        <b-col>
          <b-form-group
            id="fieldset-1"
            :label="$t('notification.text.enterNumber')"
            label-for="noHP"
          >
            <b-input-group prepend="+62">
              <b-form-input
                id="noHP"
                trim
                :placeholder="`${this.$t('global.action.enterNumber')}+...`"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import { Helper } from '@/mixin/helper'
import i18n from '@/i18n'
import { mapGetters } from 'vuex'

/**
 * Starter component
 */
export default {
  name: 'ModalCall',
  page: {
    title: 'Notifikasi',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'gmap-custom-marker': GmapCustomMarker,
  },
  mixins: [Helper],
  data() {
    return {
      showHideDetailNotif: false,
      phaseOneShow: false,
      popoverShow: false,
      detail: JSON.parse(localStorage.getItem('warning-detail-map')),
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),

    language() {
      return i18n.locale
    },

    alert_label() {
      let alerts = [
        {
          alert_code: 24,
          label: this.$t('global.alert.suddenAcceleration'),
          color: 'danger',
        },
        {
          alert_code: 23,
          label: this.$t('global.alert.suddenDeceleration'),
          color: 'danger',
        },
        {
          alert_code: 8,
          label: this.$t('global.alert.overspeed'),
          color: 'danger',
        },
        {
          alert_code: 25,
          label: this.$t('global.alert.sharpTurn'),
          color: 'danger',
        },
        {
          alert_code: 15,
          label: this.$t('global.alert.idleTime'),
          color: 'danger',
        },
        {
          alert_code: 16,
          label: this.$t('global.alert.parkTime'),
          color: 'danger',
        },
      ]
      const dms = [
        {
          alert_code: 54,
          label: this.$t('global.alert.smoking'),
          color: 'warning',
        },
        {
          alert_code: 53,
          label: this.$t('global.alert.yawning'),
          color: 'warning',
        },
        {
          alert_code: 51,
          label: this.$t('global.alert.asleep'),
          color: 'warning',
        },
        {
          alert_code: 55,
          label: this.$t('global.alert.calling'),
          color: 'warning',
        },
        {
          alert_code: 52,
          label: this.$t('global.alert.disturbance'),
          color: 'warning',
        },
        {
          alert_code: 56,
          label: this.$t('global.alert.outOfFrame'),
          color: 'warning',
        },
      ]

      if (this.hasAccessAll(['vehicle_video_trackers:read'])) {
        alerts.push(...dms)
      }
      return alerts
    },
  },
  methods: {
    checkAlert(alertCode) {
      const matchingObject = this.alert_label.find((item) => item.alert_code === alertCode)
      if (matchingObject) {
        return matchingObject.color
      } else {
        return ''
      }
    },
    convertAlert(alertCode) {
      const matchingObject = this.alert_label.find((item) => item.alert_code === alertCode)
      if (matchingObject) {
        return matchingObject.label
      } else {
        return ''
      }
    },
  },
}
</script>
